<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="SelectParam" :url="getRolesUrl" @listData='getDeviceData'></MyPage>
		</Table>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
		<MenuModal ref="MenuModal"></MenuModal>
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/RoleForm.vue';
	import infoModal from './Template/RoleModal.vue';
	import MenuModal from './Template/RoleMenuModal.vue';
	import webapi from '../../../webapi';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			infoModal,
			MenuModal
		},
		data() {
			return {
				getRolesUrl: webapi.base_api_url + '/System/GetRoles',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['系统管理', '>>', '角色管理'],
				//table标题数据
				columns1: [
					// {
					// 	title: 'ID',
					// 	key: 'Id',
					// 	width: 100
					// }, 
					{
						title: '角色名称',
						key: 'RoleName',
					},
					{
						title: '角色描述',
						key: 'RoleDesc',
					},
					// {
					// 	title: '操作者Id',
					// 	key: 'OperatorId',
					// },
					{
						title: '操作',
						key: 'action',
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up', params.row)
										}
									}
								}, '修改') : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												this.show('Menu', params.row.Id)
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, '其他操作'),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
											item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				data: [],
				methodList: [{
					Id: 0,
					name: 'grantPermission',
					Status: '分配菜单控件'
				}, ]
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 160;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				// let typeNum = (this.methodList.filter(function(item, index, arr) {
				// 	return item.Status == name
				// })[0]).Id
				// this.$axios.post(webapi.base_api_url + "/System/SetSysWidgetStatus ", {
				// 	Id: Id,
				// 	Status: typeNum
				// }).then(res => {
				// 	if (res.data.Code == 0) {
				// 		this.$Message.info(name + '成功');
				// 		this.handleSubmit();
				// 	}
				// })
			},
			/******************组件固定方法*************************/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'add':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'Menu':
						this.$refs.MenuModal.show(type, params)
						break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160;
			},
		},
	}
</script>

<style>
</style>
